<template>
    <span class="practice-timer">
        {{ getValue() }}
    </span>
</template>

<script>
import TimerMixin from "@components/Practice/common/timer/_timer"
import TimeoutWorker from "@workers/timeout-worker?worker&url"
import ResolveWorker from "@workers/resolve-worker"
import { v1 as uuid } from "uuid"

export default {
    name: "PracticeTimer",
    mixins: [TimerMixin],
    props: {
        attempt: {
            type: Object,
            default: () => ({})
        },
        trackBy: {
            type: String,
            default: "left_time_in_seconds"
        },
        onlyDisplay: {
            type: Boolean,
            default: false
        },
        increaseTime: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            intervalId: null,
            worker: null,
            seconds: 0
        }
    },
    created() {
        if (this.onlyDisplay) return

        this.seconds = this.attempt[this.trackBy] || 0
        this.worker = ResolveWorker(TimeoutWorker)()

        const tick = () => {
            this.seconds += this.increaseTime ? 1 : -1
            if (this.seconds < 0) this.seconds = 0

            this.$set(this.attempt, this.trackBy, this.seconds)
        }

        const id = uuid()
        this.worker.postMessage({
            name: "setInterval",
            id,
            time: 1000
        })
        this.worker.onmessage = tick
        this.intervalId = id
    },

    beforeDestroy() {
        if (this.intervalId && typeof this.intervalId === "number") {
            clearInterval(this.intervalId)
        }

        if (this.worker) {
            try {
                this.worker.postMessage({
                    name: "clearInterval",
                    id: this.intervalId
                })
                this.worker.terminate()
            } catch (err) {
                console.warn("Failed to terminate worker:", err)
            }
            this.worker = null
        }
    },

    methods: {
        getValue() {
            const value = this.attempt[this.trackBy] || 0

            const day = 86400
            const hour = 3600
            const minute = 60

            const days = Math.floor(value / day)
            const hours = Math.floor((value - days * day) / hour)
            const minutes = Math.floor((value - days * day - hours * hour) / minute)
            const seconds = value - days * day - hours * hour - minutes * minute

            if (days > 0) {
                const timerParts = [
                    this.num_decline(
                        days,
                        [this.t("expert.day_1"), this.t("expert.day_2"), this.t("expert.day_3")],
                        true
                    ),
                    this.num_decline(
                        hours,
                        [this.t("quiz.hours_3"), this.t("quiz.hours_2"), this.t("quiz.hours_1")],
                        true
                    ),
                    this.num_decline(
                        minutes,
                        [this.t("quiz.minutes_3"), this.t("quiz.minutes_2"), this.t("quiz.minutes_1")],
                        true
                    )
                ]
                return timerParts.join(" ").toLowerCase()
            }

            const parts = [hours, minutes, seconds].map(val => (val < 10 ? `0${val}` : val))
            return parts.join(":").toLowerCase()
        }
    }
}
</script>

<style scoped lang="sass">
.practice-timer
    color: #DD4141
    font-weight: 600
    font-size: 16px
</style>
